import * as z from "zod";

export const getStringFeatureFlag = {
  name: "getStringFeatureFlag" as const,
  input: z.object({ key: z.string(), defaultValue: z.string() }),
  output: z.object({ value: z.string() }),
};
